import { Space, Spin, Typography } from 'antd';
import React from 'react'
import { RefLanguage } from '../hooks/LanguageHooks';
import { FakeProgressBar } from '../elements/CustomProgressBars';
import { RefStoredValue } from '../hooks/StoreHooks';
import * as con from "../Constants"
import { isNullOrUndefined } from '../utils/generalFunctions';
import { CopyOutlined } from '@ant-design/icons';
import { message } from 'antd'
import { Chronometer } from '../elements/Chronometer';


const { Title } = Typography;


function SequenceBeingAnnotatedComponent({ isFinished, annotationMessage }) {


    const i18n = RefLanguage()

    const jobId = RefStoredValue(con.CURRENT_JOB_ID)

    const copyToClipboard = () => {
        if (!isNullOrUndefined(jobId)) {
            navigator.clipboard.writeText(jobId)
                .then(() => {
                    message.info(i18n.t("jobIdCopied"));

                })
        }
    }

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.9)', // semi-transparent white
                zIndex: 10,
                pointerEvents: 'auto', // allow events on this overlay
                // paddingLeft: "10vh"
            }}
        >
            <div style={{ padding: '10vh', paddingTop: "20vh", textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                <Typography >
                    <Title level={3}>{i18n.t("processing") + "..."}</Title>
                </Typography>
                <Typography >
                    <Title level={5}>{`${i18n.t("jobId")}: ${isNullOrUndefined(jobId) ? "---" : jobId}`} {isNullOrUndefined(jobId) ? <></> : <CopyOutlined style={{ fontSize: 18 }} onClick={() => copyToClipboard()} />}</Title>

                </Typography>

                <Space direction="vertical" align="center" style={{ marginTop: "2vh" }}>
                    <Spin />
                    <div style={{ marginTop: "1vh" }}>
                        <Chronometer size={22} />
                    </div>
                </Space>

                <Typography style={{ marginTop: '2vh' }}>
                    <Title level={5}>{isFinished ? i18n.t("loadingResults") : annotationMessage}</Title>
                </Typography>
                <FakeProgressBar isFinished={isFinished} showInfo={false} strokeColor={{ '100%': 'var(--primary-color-1-t)' }} />

            </div>
        </div>
    )
}

export default SequenceBeingAnnotatedComponent
